/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Integration entity
 * @export
 * @interface IntegrationCatalogEntity
 */
export interface IntegrationCatalogEntity {
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    author?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    authorType?: IntegrationCatalogEntityAuthorTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    iconUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    billOfMaterials?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    sourceCodeUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    sourceCodeVisible?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    runtimeType?: IntegrationCatalogEntityRuntimeTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    runtimeVersion?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    supportsScheduled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    supportsTriggered?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    supportsBidirectional?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    supportsRawDataCapture?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    availableFunctions?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    configurationSchema?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    defaultMappings?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    defaultTriggerRules?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof IntegrationCatalogEntity
     */
    defaultConfiguration?: { [key: string]: any; };
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    licenseType?: IntegrationCatalogEntityLicenseTypeEnum;
    /**
     * 
     * @type {number}
     * @memberof IntegrationCatalogEntity
     */
    pricePerMonth?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationCatalogEntity
     */
    downloads?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationCatalogEntity
     */
    ratingAverage?: number;
    /**
     * 
     * @type {number}
     * @memberof IntegrationCatalogEntity
     */
    ratingCount?: number;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    isVerified?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    isPublished?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    catalogScope?: IntegrationCatalogEntityCatalogScopeEnum;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    ownerTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    publishStatus?: IntegrationCatalogEntityPublishStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationCatalogEntity
     */
    publishSubmittedAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationCatalogEntity
     */
    publishReviewedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    publishReviewedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    publishReviewComment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    isSystemIntegration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    allowsMultipleInstances?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    sourceTechnologyCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationCatalogEntity
     */
    supportsPlatformDefault?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    governanceCapabilities?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationCatalogEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationCatalogEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationCatalogEntity
     */
    updatedBy?: string;
}


/**
 * @export
 */
export const IntegrationCatalogEntityAuthorTypeEnum = {
    Cobalt: 'COBALT',
    Community: 'COMMUNITY',
    Customer: 'CUSTOMER'
} as const;
export type IntegrationCatalogEntityAuthorTypeEnum = typeof IntegrationCatalogEntityAuthorTypeEnum[keyof typeof IntegrationCatalogEntityAuthorTypeEnum];

/**
 * @export
 */
export const IntegrationCatalogEntityRuntimeTypeEnum = {
    Python: 'PYTHON',
    Typescript: 'TYPESCRIPT',
    Wasm: 'WASM',
    Java: 'JAVA'
} as const;
export type IntegrationCatalogEntityRuntimeTypeEnum = typeof IntegrationCatalogEntityRuntimeTypeEnum[keyof typeof IntegrationCatalogEntityRuntimeTypeEnum];

/**
 * @export
 */
export const IntegrationCatalogEntityLicenseTypeEnum = {
    Free: 'FREE',
    Paid: 'PAID',
    Freemium: 'FREEMIUM'
} as const;
export type IntegrationCatalogEntityLicenseTypeEnum = typeof IntegrationCatalogEntityLicenseTypeEnum[keyof typeof IntegrationCatalogEntityLicenseTypeEnum];

/**
 * @export
 */
export const IntegrationCatalogEntityCatalogScopeEnum = {
    Global: 'GLOBAL',
    Tenant: 'TENANT'
} as const;
export type IntegrationCatalogEntityCatalogScopeEnum = typeof IntegrationCatalogEntityCatalogScopeEnum[keyof typeof IntegrationCatalogEntityCatalogScopeEnum];

/**
 * @export
 */
export const IntegrationCatalogEntityPublishStatusEnum = {
    Draft: 'DRAFT',
    PendingReview: 'PENDING_REVIEW',
    Published: 'PUBLISHED',
    Rejected: 'REJECTED'
} as const;
export type IntegrationCatalogEntityPublishStatusEnum = typeof IntegrationCatalogEntityPublishStatusEnum[keyof typeof IntegrationCatalogEntityPublishStatusEnum];


/**
 * Check if a given object implements the IntegrationCatalogEntity interface.
 */
export function instanceOfIntegrationCatalogEntity(value: object): value is IntegrationCatalogEntity {
    return true;
}

export function IntegrationCatalogEntityFromJSON(json: any): IntegrationCatalogEntity {
    return IntegrationCatalogEntityFromJSONTyped(json, false);
}

export function IntegrationCatalogEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationCatalogEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'slug': json['slug'] == null ? undefined : json['slug'],
        'category': json['category'] == null ? undefined : json['category'],
        'version': json['version'] == null ? undefined : json['version'],
        'author': json['author'] == null ? undefined : json['author'],
        'authorType': json['authorType'] == null ? undefined : json['authorType'],
        'description': json['description'] == null ? undefined : json['description'],
        'iconUrl': json['iconUrl'] == null ? undefined : json['iconUrl'],
        'billOfMaterials': json['billOfMaterials'] == null ? undefined : json['billOfMaterials'],
        'sourceCodeUrl': json['sourceCodeUrl'] == null ? undefined : json['sourceCodeUrl'],
        'sourceCodeVisible': json['sourceCodeVisible'] == null ? undefined : json['sourceCodeVisible'],
        'runtimeType': json['runtimeType'] == null ? undefined : json['runtimeType'],
        'runtimeVersion': json['runtimeVersion'] == null ? undefined : json['runtimeVersion'],
        'supportsScheduled': json['supportsScheduled'] == null ? undefined : json['supportsScheduled'],
        'supportsTriggered': json['supportsTriggered'] == null ? undefined : json['supportsTriggered'],
        'supportsBidirectional': json['supportsBidirectional'] == null ? undefined : json['supportsBidirectional'],
        'supportsRawDataCapture': json['supportsRawDataCapture'] == null ? undefined : json['supportsRawDataCapture'],
        'availableFunctions': json['availableFunctions'] == null ? undefined : json['availableFunctions'],
        'configurationSchema': json['configurationSchema'] == null ? undefined : json['configurationSchema'],
        'defaultMappings': json['defaultMappings'] == null ? undefined : json['defaultMappings'],
        'defaultTriggerRules': json['defaultTriggerRules'] == null ? undefined : json['defaultTriggerRules'],
        'defaultConfiguration': json['defaultConfiguration'] == null ? undefined : json['defaultConfiguration'],
        'licenseType': json['licenseType'] == null ? undefined : json['licenseType'],
        'pricePerMonth': json['pricePerMonth'] == null ? undefined : json['pricePerMonth'],
        'downloads': json['downloads'] == null ? undefined : json['downloads'],
        'ratingAverage': json['ratingAverage'] == null ? undefined : json['ratingAverage'],
        'ratingCount': json['ratingCount'] == null ? undefined : json['ratingCount'],
        'isVerified': json['isVerified'] == null ? undefined : json['isVerified'],
        'isPublished': json['isPublished'] == null ? undefined : json['isPublished'],
        'catalogScope': json['catalogScope'] == null ? undefined : json['catalogScope'],
        'ownerTenantId': json['ownerTenantId'] == null ? undefined : json['ownerTenantId'],
        'publishStatus': json['publishStatus'] == null ? undefined : json['publishStatus'],
        'publishSubmittedAt': json['publishSubmittedAt'] == null ? undefined : (new Date(json['publishSubmittedAt'])),
        'publishReviewedAt': json['publishReviewedAt'] == null ? undefined : (new Date(json['publishReviewedAt'])),
        'publishReviewedBy': json['publishReviewedBy'] == null ? undefined : json['publishReviewedBy'],
        'publishReviewComment': json['publishReviewComment'] == null ? undefined : json['publishReviewComment'],
        'isSystemIntegration': json['isSystemIntegration'] == null ? undefined : json['isSystemIntegration'],
        'allowsMultipleInstances': json['allowsMultipleInstances'] == null ? undefined : json['allowsMultipleInstances'],
        'sourceTechnologyCode': json['sourceTechnologyCode'] == null ? undefined : json['sourceTechnologyCode'],
        'supportsPlatformDefault': json['supportsPlatformDefault'] == null ? undefined : json['supportsPlatformDefault'],
        'governanceCapabilities': json['governanceCapabilities'] == null ? undefined : json['governanceCapabilities'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
    };
}

export function IntegrationCatalogEntityToJSON(json: any): IntegrationCatalogEntity {
    return IntegrationCatalogEntityToJSONTyped(json, false);
}

export function IntegrationCatalogEntityToJSONTyped(value?: IntegrationCatalogEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'slug': value['slug'],
        'category': value['category'],
        'version': value['version'],
        'author': value['author'],
        'authorType': value['authorType'],
        'description': value['description'],
        'iconUrl': value['iconUrl'],
        'billOfMaterials': value['billOfMaterials'],
        'sourceCodeUrl': value['sourceCodeUrl'],
        'sourceCodeVisible': value['sourceCodeVisible'],
        'runtimeType': value['runtimeType'],
        'runtimeVersion': value['runtimeVersion'],
        'supportsScheduled': value['supportsScheduled'],
        'supportsTriggered': value['supportsTriggered'],
        'supportsBidirectional': value['supportsBidirectional'],
        'supportsRawDataCapture': value['supportsRawDataCapture'],
        'availableFunctions': value['availableFunctions'],
        'configurationSchema': value['configurationSchema'],
        'defaultMappings': value['defaultMappings'],
        'defaultTriggerRules': value['defaultTriggerRules'],
        'defaultConfiguration': value['defaultConfiguration'],
        'licenseType': value['licenseType'],
        'pricePerMonth': value['pricePerMonth'],
        'downloads': value['downloads'],
        'ratingAverage': value['ratingAverage'],
        'ratingCount': value['ratingCount'],
        'isVerified': value['isVerified'],
        'isPublished': value['isPublished'],
        'catalogScope': value['catalogScope'],
        'ownerTenantId': value['ownerTenantId'],
        'publishStatus': value['publishStatus'],
        'publishSubmittedAt': value['publishSubmittedAt'] == null ? undefined : ((value['publishSubmittedAt']).toISOString()),
        'publishReviewedAt': value['publishReviewedAt'] == null ? undefined : ((value['publishReviewedAt']).toISOString()),
        'publishReviewedBy': value['publishReviewedBy'],
        'publishReviewComment': value['publishReviewComment'],
        'isSystemIntegration': value['isSystemIntegration'],
        'allowsMultipleInstances': value['allowsMultipleInstances'],
        'sourceTechnologyCode': value['sourceTechnologyCode'],
        'supportsPlatformDefault': value['supportsPlatformDefault'],
        'governanceCapabilities': value['governanceCapabilities'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
    };
}

